module.exports = __webpack_public_path__ + "static/media/co_masmillon.336e744a.png";